module.exports = __webpack_public_path__ + "img/1555025240.afc73623.jpg";